export const GrowersContactInfo = {
  growersWebsite: 'https://growers.ag',
  supportEmail: 'appsupport@growers.ag',
  supportPhone: '9192130230',
  termsOfUseLink: 'https://growers.ag/privacy-policy/#termsofuse',
  privacyPolicyLink: 'https://growers.ag/privacy-policy/#privacypolicy',
  learnHowLink: 'https://www.youtube.com/shorts/GiUkwspzJkY',
};
